import type { JSX } from 'react';

import { InsufficientPermissionsError } from 'common/components/InsufficientPermissionsError';
import { Roles } from 'common/constants/roles';

type PrivateElementProps = {
    roles?: Array<Roles>;
    element: JSX.Element;
    isAuthenticated: boolean;
    rolesChecked: boolean;
    currentUserRoles: string[];
};

export const PrivateElement = ({
    roles,
    element,
    isAuthenticated,
    rolesChecked,
    currentUserRoles
}: PrivateElementProps): JSX.Element | null => {
    const userHasRequiredRole = roles?.some((r) => currentUserRoles?.includes(r));
    const userNotAllowed = !isAuthenticated || (rolesChecked && !userHasRequiredRole);
    return  userNotAllowed
        ? <InsufficientPermissionsError />
        : element;
};
